import React, { useCallback } from 'react';
import Button from '@atlaskit/button/new';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { useAnalyticsEvents, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { ProjectCreateDrawerConsumer } from '@atlassian/jira-project-create-drawer-context';
import type { OpenDrawerMethod } from '@atlassian/jira-project-create-drawer-context/src/types';
import messages from './messages';

const ImportButton = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { formatMessage } = useIntl();

	const handleImportButtonClick = useCallback(
		(open: OpenDrawerMethod) => {
			open({
				isNextGen: true,
				showExperienceSelection: false,
				source: 'importDiscoveryProjectsDirectoryCTA',
				isImportProjectOpenInitially: true,
			});
			fireUIAnalytics(
				createAnalyticsEvent({}),
				'button clicked',
				'importDiscoveryProjectsDirectoryCTA',
			);
		},
		[createAnalyticsEvent],
	);

	return (
		<ProjectCreateDrawerConsumer>
			{({ methods: { open } }) => (
				<Button onClick={() => handleImportButtonClick(open)}>
					{formatMessage(messages.importProject)}
				</Button>
			)}
		</ProjectCreateDrawerConsumer>
	);
};

const ImportButtonContainer = () => (
	<JSErrorBoundary id="import-project-button" packageName="jiraProjectsDirectoryV3" fallback="flag">
		<ImportButton />
	</JSErrorBoundary>
);

export { ImportButtonContainer as ImportButton };
